export const checkIsCaseSensitive = (currentCase: boolean | undefined) => {
	return currentCase ? 'g' : 'gi';
};
